import * as React from "react";
const SvgFiRrCustomerService = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.5 9.5c0 .55.128 1.073.356 1.537a3.97 3.97 0 0 0-.836 2.256A5.48 5.48 0 0 1 6.5 9.5a5.51 5.51 0 0 1 6.66-5.381c2.081.428 3.768 2.105 4.212 4.184.134.628.16 1.243.091 1.83a.996.996 0 0 1-.997.867h-.045c-.592 0-1.008-.527-.943-1.115a3.486 3.486 0 0 0-2.655-3.79A3.507 3.507 0 0 0 8.5 9.5zM4.61 8.205a7.43 7.43 0 0 1 2.261-4.178c1.53-1.433 3.531-2.141 5.63-2.011 3.953.256 7.044 3.719 6.998 7.865-.019 1.736-1.473 3.118-3.208 3.118h-2.406a1.994 1.994 0 0 0-3.91.56 2 2 0 0 0 2 2c.538 0 1.025-.214 1.384-.56h2.932c2.82 0 5.168-2.245 5.208-5.063C21.573 4.715 17.651.345 12.63.02a9.4 9.4 0 0 0-7.126 2.548A9.54 9.54 0 0 0 2.65 7.835 1 1 0 0 0 3.64 9c.471 0 .892-.33.971-.795zM12 17c-3.695 0-6.892 2.292-7.955 5.702a1 1 0 0 0 .657 1.253 1.006 1.006 0 0 0 1.252-.657c.351-1.127 1.052-2.09 1.952-2.825l1.401 2.1a.896.896 0 0 0 1.491 0l1.254-1.881 1.254 1.882a.896.896 0 0 0 1.491 0l1.363-2.044c.867.729 1.542 1.67 1.884 2.768a1 1 0 0 0 1.91-.596C18.891 19.292 15.694 17 12 17z"
    />
  </svg>
);
export default SvgFiRrCustomerService;
